import * as types from '../types'

export const listBaseReq = (data) => ({
  type: types.LIST_BASE_REQ,
  data
})
export const listBaseHandle = (data) => ({
  type: types.LIST_BASE_HANDLE,
  data
})


export const listReq = (data) => ({
  type: types.LIST_REQ,
  data
})

export const listHandle = (data) => ({
  type: types.LIST_HANDLE,
  data
})

export const taskReq = (data) => ({
  type: types.TASK_REQ,
  data
})

export const taskHandle = (data) => ({
  type: types.TASK_HANDLE,
  data
})
